<template>
  <div class="personChargeBox">
    <div class="head">
      <el-breadcrumb style="margin-left:20px" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/processManager/ProcessPersonCharge'}">三包负责人</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.params.key ? '编辑' : '新增' }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="content">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" size="small" label-width="120px" class="demo-ruleForm">
        <el-form-item prop="userId" label="账户">
          <el-select v-model="ruleForm.userId" style="width: 100%" placeholder="请选择账户">
            <el-option v-for="item in accountList" :key="item.id" :label="item.account" :value="item.id" />
          </el-select>
        </el-form-item>
        <el-form-item prop="employeeId" label="姓名">
          <Select v-model="ruleForm.employeeId">
            <Option v-for="type in employeeList"
                    :value="type.id"
                    :key="type.id">{{ type.name }}
            </Option>
          </Select>
        </el-form-item>
        <el-form-item prop="sex" label="性别">
          <el-radio-group v-model="ruleForm.sex" size="small">
            <el-radio-button :label="1">男</el-radio-button>
            <el-radio-button :label="2">女</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="籍贯">
          <el-input v-model="ruleForm.nativePlace" placeholder="籍贯" />
        </el-form-item>
        <el-form-item label="民族">
          <el-input v-model="ruleForm.ethnic" placeholder="民族" />
        </el-form-item>
        <el-form-item prop="birthday" label="出生年月">
          <el-date-picker v-model="ruleForm.birthday" type="date" value-format="yyyy-MM-dd HH:mm:ss" placeholder="请选择日期" />
        </el-form-item>
        <el-form-item prop="certificateType" label="证件类型">
          <el-select v-model="ruleForm.certificateType" style="width: 100%" placeholder="请选择证件类型">
            <el-option v-for="itemZJ in documentTypeList" :key="itemZJ.id" :label="itemZJ.name" :value="itemZJ.id" />
          </el-select>
        </el-form-item>
        <el-form-item prop="idNumber" label="证件号码">
          <el-input v-model="ruleForm.idNumber" placeholder="证件号码" />
        </el-form-item>
        <el-form-item prop="education" label="最高学历">
          <Select v-model="ruleForm.education">
            <Option v-for="type in educationList"
                    :value="type.id"
                    :key="type.id">{{ type.name }}
            </Option>
          </Select>
        </el-form-item>
        <el-form-item label="最高学位">
          <el-input v-model="ruleForm.degree" placeholder="最高学位" />
        </el-form-item>
        <el-form-item label="最后毕业院校">
          <el-input v-model="ruleForm.graduationAcademy" placeholder="最后毕业院校" />
        </el-form-item>
        <el-form-item label="专业">
          <el-input v-model="ruleForm.specialty" placeholder="专业" />
        </el-form-item>
        <el-form-item prop="politicsStatus" label="政治面貌">
          <el-input v-model="ruleForm.politicsStatus" placeholder="政治面貌" />
        </el-form-item>
        <el-form-item label="健康状况">
          <el-input v-model="ruleForm.healthCondition" placeholder="健康状况" />
        </el-form-item>
        <el-form-item label="职务">
          <el-input v-model="ruleForm.position" placeholder="职务" />
        </el-form-item>
        <el-form-item label="职称">
          <el-input v-model="ruleForm.professionalTitle" placeholder="职称" />
        </el-form-item>
        <el-form-item prop="jobDuties" label="工作职责">
          <el-input v-model="ruleForm.jobDuties" placeholder="工作职责" />
        </el-form-item>
        <el-form-item label="工作经历">
          <el-input v-model="ruleForm.occupationalHistory" placeholder="工作经历" />
        </el-form-item>
        <el-form-item label="办公电话">
          <el-input v-model="ruleForm.officePhone" placeholder="办公电话" />
        </el-form-item>
        <el-form-item label="移动电话">
          <el-input v-model="ruleForm.mobileTelephone" placeholder="移动电话" />
        </el-form-item>
        <el-form-item label="电子邮箱">
          <el-input v-model="ruleForm.emailAddress" placeholder="电子邮箱" />
        </el-form-item>
        <el-form-item prop="hiredate" label="进入本单位日期">
          <el-date-picker v-model="ruleForm.hiredate" type="date" placeholder="请选择日期" value-format="yyyy-MM-dd HH:mm:ss" />
        </el-form-item>
        <el-form-item label="工龄">
          <el-input v-model="ruleForm.workingYears" type="number" placeholder="请填写工龄" />
        </el-form-item>
        <el-form-item label="资格证书类型">
          <!-- <el-input v-model="ruleForm.certificateTypeId" placeholder="资格证书类型" /> -->
          <el-select v-model="ruleForm.certificateTypeId" placeholder="请选择资格证书类型" style="width: 100%">
            <el-option v-for="itemZG in options" :key="itemZG.id" :value="itemZG.id" :label="itemZG.name" />
          </el-select>
        </el-form-item>
        <el-form-item label="证书编号">
          <el-input v-model="ruleForm.certificateNo" placeholder="证书编号" />
        </el-form-item>
        <el-form-item label="证书有效期起">
          <el-date-picker v-model="ruleForm.effectiveDateStart" type="date" placeholder="请选择日期" value-format="yyyy-MM-dd HH:mm:ss" />
        </el-form-item>
        <el-form-item label="证书有效期止">
          <el-date-picker v-model="ruleForm.effectiveDateEnd" type="date" placeholder="请选择日期" value-format="yyyy-MM-dd HH:mm:ss" />
        </el-form-item>
        <el-form-item label="证书上传">
          <div class="zsUpload">
            <el-upload
              class="upload-demo"
              drag
              :file-list="fileList"
              :on-success="zsUploadSuccess"
              :on-error="zsUploadFail"
              :on-remove="zsRemove"
              :on-exceed="zsExceed"
              :limit="1"
              style="width: 100%"
              action="/v1/modifyform/uploadFile/1"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text" style="width: 100%">将文件拖到此处，或<em>点击上传</em></div>
            </el-upload>
          </div>
        </el-form-item>
        <el-form-item label="照片">
          <el-upload
            class="avatar-uploader"
            action="/v1/modifyform/uploadFile/1"
            :show-file-list="false"
            accept=".jepg,.jpg,.png,.gif,.svg"
            :on-success="handleAvatarSuccess">
            <img v-if="ruleForm.certificatePicture" :src="host + ruleForm.certificatePicture" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="备注">
          <el-input type="textarea" v-model="ruleForm.remark" :rows="3" placeholder="请填写备注" />
        </el-form-item>
        <el-form-item label="" style="margin-top: 35px">
          <el-button type="primary" style="width: 100%" @click="submit">保存</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { getAlluser, responsiblePersonsAdd, responsiblePersonsUpdate, getWorkType } from '@/api/processManager'
import { getWorkerList } from '@/api/map'
export default {
  name: 'AddPersonCharge',
  data() {
    return {
      ruleForm: {
        sex: 1
      },
      rules: {
        userId: [{ required: true, message: '请选择账户' }],
        employeeId: [{ required: true, message: '请输入姓名' }],
        birthday: [{ required: true, message: '请选择出生年月' }],
        certificateType: [{ required: true, message: '请选择证件类型' }],
        idNumber: [{ required: true, message: '请输入证件号码' }],
        politicsStatus: [{ required: true, message: '请输入政治面貌' }],
        jobDuties: [{ required: true, message: '请输入工作职责' }],
        hiredate: [{ required: true, message: '请选择日期' }],
      },
      // 账户的列表
      accountList: [],
      employeeList: [],
      educationList: [
        {id: 1, name: '小学'},
        {id: 2, name: '初中'},
        {id: 3, name: '高中'},
        {id: 4, name: '大专'},
        {id: 5, name: '本科'},
        {id: 6, name: '研究生'},
        {id: 7, name: '硕士'},
        {id: 8, name: '博士'},
        {id: 9, name: '博士后'},
      ],
      // 证书类型列表
      documentTypeList: [
        { id: 1, name: '居民身份证' },
        { id: 2, name: '军人证' },
        { id: 3, name: '港澳台居民身份证' },
        { id: 4, name: '华侨身份证' },
        { id: 5, name: '外籍护照' },
        { id: 6, name: '其他' }
      ],
      // 资格证书类型
      options: [],
      prop: {
        label: 'name',
        children: 'childList'
      },
      // 证书上传存放的数组
      fileList: []
    }
  },
  created() {
    this.getUserData();
    this.getWorkType();
    this.getEmployeeList();
    if(this.$route.params.key) {
      this.ruleForm = this.$route.params.key
      if(this.$route.params.key.certificateFileUrl) {
        this.fileList.push({
          name: this.$route.params.key.certificateFileName,
          response: { data: this.$route.params.key.certificateFileUrl }
        })
      }
    }
  },
  methods: {
    // 获取所有用户列表
    getUserData() {
      getAlluser().then(res => {
        this.accountList = res.body.data
      })
    },
    getEmployeeList(){
      getWorkerList().then(res => {
        var employeeList = []
        res.data.data.forEach((item, index) => {
          if (item.education > 3 ) {
            employeeList.push(item)
          }
        })
        this.employeeList = employeeList
      })
    },

    // 上传头像的事件
    handleAvatarSuccess(res, file) {
      // this.ruleForm.certificatePicture = res.data
      this.$set(this.ruleForm, 'certificatePicture', res.data)
    },
    // 上传证书成功
    zsUploadSuccess(file, fileList) {
      this.fileList = fileList
    },
    // 移除
    zsRemove(file, fileList) {
      this.fileList = [];
    },
    // 超出限制个数
    zsExceed() {
      this.$message.warning('限制上传一个文件')
    },
    // 上传失败
    zsUploadFail(file) {
      this.fileList = []
      this.$message.warning('上传失败，请重新上传');
    },
    // 获取资格证类型
    getWorkType() {
      getWorkType({ type: 2 }).then(res => {
       this.options = res.body.data[0].childList;
      })
    },
    // 保存
    submit() {
      this.$refs['ruleForm'].validate((valid) => {
        if(valid) {
          let obj = { ...this.ruleForm }
          if(this.fileList.length !== 0) {
            obj.certificateFileName = this.fileList[0].name
            obj.certificateFileUrl = this.fileList[0].response.data
          }
          // 编辑
          if(this.$route.params.key) {
            delete obj.gmtCreate
            responsiblePersonsUpdate(obj).then(res => {
              this.$message.success('保存成功');
              this.$router.push('ProcessPersonCharge')
            })
          }
          // 新增
          else {
            responsiblePersonsAdd(obj).then(res => {
              this.$message.success('保存成功');
              this.$router.push('ProcessPersonCharge')
            })
          }
        }
        else{
          return false;
        }
      })
    }
  }
}
</script>

<style scoped>
.demo-ruleForm {
  margin: auto;
  width: 60%
}
.personChargeBox .zsUpload /deep/ .el-upload {
  width: 100%
}
.personChargeBox /deep/ .el-upload-dragger {
  width: 100%
}
</style>
